import { connect } from 'react-redux';
import ScribeFinalTranscriptList from './ScribeFinalTranscriptList';
const mapStateToProps = (state) => {
    const { scribeConversation: { transcripts }, } = state;
    return {
        transcripts,
    };
};
export default connect(mapStateToProps)(ScribeFinalTranscriptList);
